module.exports = __webpack_public_path__ + "static/media/face3.7c463176.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/face3.png
// module id = 439
// module chunks = 0